import { useEffect } from "react";
import axios, { API } from "@/lib/api";

const KEY = "remote_autojoin_at";
const DAY = 24 * 3600 * 1000;

// Desktop only: once the store accepted remote maintenance, every PC joins the tailnet by itself (no click needed).
export function RemoteAutoJoin() {
  useEffect(() => {
    const d = window.selloxDesktop;
    if (!d?.remoteEnable || !d?.remoteStatus) return;
    const attempt = async () => {
      try {
        const token = localStorage.getItem("token") || localStorage.getItem("pos_token");
        if (!token) return;
        if (Date.now() - Number(localStorage.getItem(KEY) || 0) < DAY) return;
        const st = (await axios.get(`${API}/remote/status`, { skipGlobalError: true, timeout: 8000 })).data;
        if (!st?.enabled || !st?.configured) return;
        const local = await d.remoteStatus();
        if (local?.up) return;
        localStorage.setItem(KEY, String(Date.now()));
        const r = await d.remoteEnable(token, localStorage.getItem("sellox_device_id") || "desktop");
        if (!r?.ok) localStorage.setItem(KEY, String(Date.now() - DAY + 3600 * 1000));  // failed → try again in 1 h (not tomorrow)
        console.log("[remote-autojoin]", r);
      } catch (e) { console.warn("[remote-autojoin]", e?.message); }
    };
    // tills stay open for days without a reload → keep retrying (failed attempts back off 1 h, success once a day)
    const t = setTimeout(attempt, 45000);
    const iv = setInterval(attempt, 30 * 60 * 1000);
    return () => { clearTimeout(t); clearInterval(iv); };
  }, []);
  return null;
}
